import React from "react";
import styled from "styled-components";

import { PlatformIcon } from "entities/accounts";

import { postPlatformsConfig } from "./../postPlatforms.config";
import youtubeIconUtils from "utils/youtube-icon-utils";

const PlatformUsage = ({
  platforms,
  field,
  selectedPlatform,
  className = "",
}) => {
  if (selectedPlatform !== "LINKED") {
    return <></>;
  }

  return (
    <Platforms className={className}>
      {platforms.map((platform) => {
        const fields = postPlatformsConfig[platform.TYPE].fields;
        const type = youtubeIconUtils.resolveYtRedIcon(platform.NAME);
        if (!fields.includes(field)) {
          return "";
        }

        return (
          <PlatformIcon
            key={`${field}-${platform.TYPE}`}
            className="mr-2"
            type={type}
          />
        );
      })}
    </Platforms>
  );
};

const Platforms = styled.div`
  height: 19px;
  display: flex;
  align-items: center;

  ${PlatformIcon} {
    width: 15px;
    height: 15px;
  }
`;

export default PlatformUsage;
